import { useState, useEffect } from "react";
import logo from "./img/logo-beta.svg";

type isLoggedIn = boolean;

export default function Header() {

    const [loggedIn, setLoggedIn] = useState<isLoggedIn>();

    useEffect(() => {
        const api = async () => {
            const data = await fetch("https://omnilabs.ai/logged_in", {
                method: "GET"
            });
            const jsonData = await data.json();
            console.log("Response 'data' was " + data);
            console.log("Response 'jsonData' was " + jsonData);
            if (data.ok) {
                setLoggedIn(jsonData)
                console.log("loggedIn is set to " + loggedIn);
            } else {
                console.log(new Error("Failed to get logged in"))
            }
            setLoggedIn(true);
        };

        console.log("Fetching from api...");
        api();
    }, []);

    return (
        <div className="header header_fixed header_sticky container-fluid">
            <div className="header__container header__controls">
                <div className="row justify-content-between align-items-center">
                    <div className="col-auto">
                        <a className="logo" href="https://omnilabs.ai/manage_datasets">
                            <img className="logo-img" src={logo} alt="Omni"/>
                        </a>
                    </div>
                    <div className="col-auto d-none d-lg-block">
                        {loggedIn ? (
                            <ul className="menu js-menu">
                                <li>
                                    <a href="https://omnilabs.ai/chat"
                                    ><i className="fa fa-cloud-upload"></i> Chat
                                    </a>
                                </li>
                                <li>
                                    <a href="https://omnilabs.ai/manage_datasets#my_datasets">Datasets</a>
                                </li>
                                <li>
                                    <a href="https://omnilabs.ai/create_prompt">Prompts</a>
                                </li>
                                <li className="menu-item-has-children">
                                    <a href="https://omnilabs.ai/onboarding">Guide</a>
                                    <ul className="sub-menu">
                                        <li><a href="https://omnilabs.ai/onboarding#section1">Installation</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section2">Google Docs</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section3">Upload Dataset</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section4">Select Dataset</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section5">Using Omni</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section6">Share Dataset</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section7">Internet Browsing</a></li>
                                        <li><a href="https://omnilabs.ai/onboarding#section8">Omni Write App</a></li>
                                    </ul>
                                </li>
                                <li className="menu-item-has-children">
                                    <a href="https://omnilabs.ai/manage_datasets">My Account</a>
                                    <ul className="sub-menu">
                                        <li><a href="/" target="_blank">Write</a></li>
                                        <li><a href="https://omnilabs.ai/unsubscribe">Cancel</a></li>
                                        <li><a href="https://omnilabs.ai/privacy">Privacy</a></li>
                                        <li><a href="https://omnilabs.ai/logout">Log Out</a></li>
                                    </ul>
                                </li>
                            </ul>
                        ) : (
                            <ul className="menu js-menu">
                                <li>
                                    <a
                                    href="https://chrome.google.com/webstore/detail/consilience/mlcoidohpcjfjnknjjggenjccckcgmpn"
                                    >Get the Extension</a>
                                </li>
                                <li><a href="https://omnilabs.ai/login">Login</a></li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}